import React from 'react';
import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf';
import OrdinationPage from './ordination_page';

class Confirmation extends OrdinationPage {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    this.props.clearPartialMinister();
  }
 
  render() {
    return (
      <div className={ this.props.className } id='ordination-complete-panel'>
        <Document file = { `/ministers/${this.props.minister.id}/certificate.pdf` } >
          <Page pageNumber={1} width={350} />
        </Document>
      </div>
    );
  }
}

Confirmation.propTypes = {
  className: PropTypes.string,
  pageNumber: PropTypes.number,
  minister: PropTypes.object.isRequired,
  clearPartialMinister: PropTypes.func.isRequired,
};

export {
  Confirmation
};
